import React, { PureComponent } from "react";
import classNames from "classnames";

export default class YesNo extends PureComponent {
  constructor() {
    super();

    this.inputContols = [];
  }

  handleChange(value) {
    if (this.props.Value !== value) {
      this.props.onValueChanged([value]);
    }
  }

  render() {
    const { Value, AvailableOptions } = this.props;
    return (
      <div className="yes-no">
        <div>
          {AvailableOptions.filter((i) => i.Text !== "").map((listOption) => (
            <input
              type="button"
              key={listOption.Value}
              ref={(input) => {
                this.inputContols.push(input);
              }}
              className={classNames({
                "btn btn-default btn-md btn-or": true,
                selected: Value === listOption.Value,
              })}
              value={listOption.DisplayLabel}
              onClick={() => this.handleChange(listOption.Value)}
            />
          ))}
        </div>
      </div>
    );
  }
}
